import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import TicketArrow from "../../../common/ticket-arrow/ticket-arrow";

//import images and icons
import { Airplane } from "iconsax-react";
import AirplaneSvg from "../../../../assets/icons/airplane.svg";

function TourFlight({ title, flightClass, airline, departure, destination, duration, departureTime, arrivedTime }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid container item xs={12} rowGap={2}>
            <Grid container item xs={12} columnGap={2}>
                <Grid className="flight-item__title" container item xs="auto">
                    <span>{title}</span>
                </Grid>
                {flightClass && (
                    <Grid className="flight-item__label" container item xs="auto">
                        <span>{flightClass}</span>
                    </Grid>
                )}
            </Grid>

            <Grid container item xs={12} justifyContent="space-between" alignItems={{ xs: "center", md: "flex-start" }}>
                <Grid container item xs={3.5} md={4} rowGap={1} columnGap={1} direction="column" alignItems="flex-start">
                    <Grid container item xs="auto" columnGap={1} justifyContent={{ xs: "center", md: "flex-start" }}>
                        {airline?.map((segment, index) => {
                            return <img className="flight-item__int-airline-logo" key={index} src={segment?.logo} alt={airline?.english_name} />;
                        })}
                    </Grid>
                    <Grid container item xs={12} md="auto" rowGap={1}>
                        <span className="flight-item__airline-name">
                            {airline?.length > 1 ? t("multipleAirlines") : locale === "fa" ? airline[0]?.name : airline[0]?.english_name}
                        </span>
                    </Grid>
                </Grid>

                <Grid container item xs={8.5} md={8} rowGap={4}>
                    <Grid container item xs={12} justifyContent="space-around" alignItems="center">
                        <Grid container item xs="auto" direction="column" justifyContent="cenetr" alignItems="center">
                            <Grid className="flight-item__city-name" component="span" container item xs="auto" >
                                {locale === "fa" ? departure?.name : departure?.english_name} ({departure?.code})
                            </Grid>
                            <span className="flight-item__time">{departureTime?.split("T")[1]?.split(":", 2).join(":")}</span>
                        </Grid>

                        <TicketArrow icon={<img src={AirplaneSvg} />} />

                        <Grid container item xs="auto" direction="column" justifyContent="cenetr" alignItems="center">
                            <Grid className="flight-item__city-name" component="span" container item xs="auto" >
                                {locale === "fa" ? destination?.name : destination?.english_name} ({destination?.code})
                            </Grid>
                            <span className="flight-item__time">{arrivedTime?.split("T")[1]?.split(":", 2).join(":")}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="flight-item__total-duration-time"
                        container
                        item
                        xs={12}
                        justifyContent="center"
                        alignItems="center"
                        display={{ xs: "none", md: "flex" }}
                    >
                        <span>
                            {duration?.split(":", 2).join(":")} {t("hours")}
                        </span>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default TourFlight;
